import * as React from "react";
import { BaseIcon, BaseIconProps } from "@/components/icons/primitives/BaseIcon";

/**
 * Telegram Standard icon - official Telegram brand with blue gradient
 * Use this for external links and compositions where you want the official look
 *
 * @example
 * ```tsx
 * <TelegramStandardIcon size="md" />
 * ```
 */
export const TelegramStandardIcon = React.forwardRef<SVGSVGElement, Omit<BaseIconProps, "children">>((props, ref) => {
  return (
    <BaseIcon ref={ref} aria-label="Telegram" viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_telegram)" />
      <path
        d="M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z"
        fill="white"
      />
      <defs>
        <linearGradient id="paint0_linear_telegram" x1="16" y1="2" x2="16" y2="30" gradientUnits="userSpaceOnUse">
          <stop stopColor="#37BBFE" />
          <stop offset="1" stopColor="#007DBB" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
});

TelegramStandardIcon.displayName = "TelegramStandardIcon";
